import { Nomination, PagedModel, TruckNomination } from "../models";
import { Get, Patch, Post } from "./apiUtils";

const updateSurveyorAsync = async (
  nominationNo: number,
  surveyor: string
): Promise<Nomination> => {
  const nomination = [
    {
      op: "replace",
      path: "/surveyor",
      value: surveyor
    }
  ];
  const response = await Patch(
    `api/nomination/${nominationNo}`,
    JSON.stringify(nomination)
  );
  const result = await response.json();
  return result;
};

const getNominationListAsync = async (
  modality: number,
  status: string,
  salesOrg: string,
  pageNo: number = 1,
  pageSize: number = 5,
  keyword: string = ""
): Promise<PagedModel<TruckNomination>> => {
  const response = await Get(
    `/api/nomination/${status}?modality=${modality}&salesOrg=${salesOrg}&pageNo=${pageNo}&pageSize=${pageSize}&keyword=${keyword}`
  );
  const result = await response.json();
  return result;
};

const resetData = async (): Promise<boolean> => {
    try {
        await Post(
            `api/nomination/reset-data`,
            null
        );
        return true;
    } catch (ex) {
        return false;
    }
};

export const NominationApi = {
  updateSurveyorAsync,
    getNominationListAsync,
    resetData
};
